module.exports = __webpack_public_path__ + "static/media/saverafrica-logo.4b897ed8.svg";